import { render, staticRenderFns } from "./TwitchProfileChaptersTable.vue?vue&type=template&id=5c255011&scoped=true&"
import script from "./TwitchProfileChaptersTable.vue?vue&type=script&lang=js&"
export * from "./TwitchProfileChaptersTable.vue?vue&type=script&lang=js&"
import style0 from "./TwitchProfileChaptersTable.vue?vue&type=style&index=0&id=5c255011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c255011",
  null
  
)

export default component.exports